import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agregar-pagos',
  templateUrl: './agregar-pagos.component.html',
  styleUrls: ['./agregar-pagos.component.css']
})
export class AgregarPagosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
